import { motion } from "framer-motion";

export const SectionHeader = ({ title, sub, light = false }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    className="mb-12 md:mb-16 max-w-3xl"
  >
    <h2 className={`font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.08] ${light ? "text-white" : "text-slate-900"}`}>
      {title}
    </h2>
    {sub && <p className={`mt-5 text-base md:text-lg leading-relaxed ${light ? "text-blue-100/90" : "text-slate-600"}`}>{sub}</p>}
  </motion.div>
);
